import {FC} from 'react'
import {useWatch} from 'react-hook-form'
import {AddCrewTable} from '../table/crew'

interface Props {
  prevStep: () => void
  nextStep: () => void
  goToStep: (index: number) => void
}

export const RegistrationStep: FC<Props> = ({prevStep, nextStep, goToStep}) => {
  const census = useWatch({name: 'census'})

  const censusOk = useWatch({name: 'censusOk'})
  const hasCrewUsers = useWatch({name: 'hasCrewUsers'})
  const hasCrewLeader = useWatch({name: 'hasCrewLeader'})
  const canProcessCleaning = Boolean(hasCrewUsers) && Boolean(hasCrewLeader)

  const handleNext = () => {
    if (census) {
      nextStep()
    } else {
      goToStep(3) // Navegar a Programación cuando no es censo (step 3, índice 2)
    }
  }

  const censusValidation = censusOk && census

  return (
    <div className='w-100 pb-20 pb-lg-0'>
      {/* <div className='pb-10 pb-lg-15'>
        <h2 className='fw-bolder d-flex align-items-center text-dark'>Bienvenido</h2>
        <div className='fw-bold fs-6'>¿Qué operación desea realizar?</div>
      </div> */}

      <div className='fv-row position-relative'>
        <AddCrewTable />
      </div>
      <div className='d-none d-lg-flex flex-stack pt-8 justify-content-between'>
        {censusValidation ? (
          <button type='button' className='btn btn-sm btn-primary' onClick={nextStep}>
            Censo
          </button>
        ) : (
          <div></div>
        )}
        <button
          type='button'
          className='btn btn-sm btn-primary'
          onClick={() => goToStep(3)}
          disabled={!canProcessCleaning}
        >
          Proceso de Limpieza
        </button>
      </div>
      <div
        className='d-flex d-lg-none position-fixed bottom-0 start-0 end-0 bg-white border-top px-4 py-3 justify-content-between'
        style={{zIndex: 105}}
      >
        {censusValidation ? (
          <button
            type='button'
            className='btn btn-sm btn-primary me-3 flex-grow-1'
            onClick={nextStep}
          >
            Censo
          </button>
        ) : (
          <div className='me-3 flex-grow-1'></div>
        )}
        <button
          type='button'
          className='btn btn-sm btn-primary flex-grow-1'
          onClick={() => goToStep(3)}
          disabled={!canProcessCleaning}
        >
          Proceso de Limpieza
        </button>
      </div>
    </div>
  )
}
